import React, { useEffect } from "react";
import { GoogleMap, InfoWindow, Marker, OverlayView } from "@react-google-maps/api";
import { ColorsContext } from "../../Context/ColorsContext";


export const MapViewMinimal = ({
  mapRef,
  mapCenter,
  mapZoom,
  tableData = [],
  selected,
  activeMarkerId,
  onMarkerClick,
  onCloseInfo,
  loadWorkflowCount,
  fitBound = false
}) => {

    const { colors } = React.useContext(ColorsContext);

    useEffect(() => {
        if (!mapRef.current) return;
        if (!tableData || tableData.length === 0) return;
        // Verificar que la librería de Google Maps esté disponible
        if (!window.google || !window.google.maps) return;

        if (fitBound) {
            const bounds = new window.google.maps.LatLngBounds();
    
            tableData.forEach(p => {
                if (p.lat != null && p.lng != null) {
                    bounds.extend({ lat: p.lat, lng: p.lng });
                }
            });

            mapRef.current.fitBounds(bounds);

            // Forzar zoom máximo cuando Google termine de ajustar
            window.google.maps.event.addListenerOnce(
                mapRef.current,
                "bounds_changed",
                () => {
                    const MAX_ZOOM = 19;
                    if (mapRef.current.getZoom() < MAX_ZOOM) {
                        mapRef.current.setZoom(MAX_ZOOM);
                    }
                }
            );
        }

    }, [tableData, mapRef, fitBound]);

    return (
        <GoogleMap
            mapContainerStyle={{ width: "100%", height: "100%" }}
            center={mapCenter}
            zoom={mapZoom}
            onLoad={map => (mapRef.current = map)}
            options={{
                mapTypeId: "satellite",
                disableDefaultUI: true,
                mapTypeControl: true,
                streetViewControl: false,
                fullscreenControl: false
            }}
        >
            {tableData.map((item) => {
                // Verificar que Google Maps esté completamente cargado antes de usar SymbolPath
                const hasGoogleMaps = window.google && window.google.maps && window.google.maps.SymbolPath;
                
                return (
                    <Marker
                        key={item.id}
                        position={{ lat: item.lat, lng: item.lng }}
                        onClick={onMarkerClick ? () => onMarkerClick(item) : undefined}
                        label={{
                            text: String(item.index),
                            color: "white",
                            fontSize: "12px",
                            fontWeight: "bold",
                        }}
                        icon={hasGoogleMaps ? {
                            path: window.google.maps.SymbolPath.CIRCLE,
                            fillColor: item.id === activeMarkerId ? colors.mainGreen : colors.orange,
                            fillOpacity: 1,
                            strokeColor: colors.white,
                            strokeWeight: 2,
                            scale: 14,
                        } : undefined}
                    />
                );
            })}

            {selected && (
                <InfoWindow
                    position={{ lat: selected.lat, lng: selected.lng }}
                    onCloseClick={onCloseInfo}
                >
                    <div
                        style={{
                            minWidth: 180,
                            borderRadius: 8,
                            background: colors.background,
                            padding: 10,
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: 6
                            }}
                        >
                            <strong style={{ fontSize: 14 }}>
                                {selected.name}
                            </strong>

                            <span
                                style={{
                                    cursor: "pointer",
                                    fontSize: 16,
                                    fontWeight: "bold",
                                }}
                                onClick={onCloseInfo}
                            >
                                ✕
                            </span>
                        </div>

                        <div style={{ fontSize: 12 }}>
                            {loadWorkflowCount?.(selected)}
                        </div>
                    </div>
                </InfoWindow>
            )}
        </GoogleMap>
    )
}
